import { AssetOverview } from '~/app/components/asset-overview/AssetOverview';

export const AssetOverviewContainer = () => <AssetOverview />;
